<div [formGroup]="SettingForm" class="one" fxLayout="column">
  <h3 class="mt-[5px] mb-0 text-[14px]">
    <b>Do you charge invoices in foreign currencies?</b>
    <br />
    <br />
    If you do you can enter the exchange rate for each currency that you want to charge. Enter the
    rate at the date that is applicable and SILQ will calculate the correct rate.
  </h3>
  <br />
  <div class="border-line"></div>
  <br />
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
<h1 fxFlex="100" class="pr-1"><strong>Exchange Rates</strong></h1>
</div> -->

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field fxFlex="20" class="example pr-1" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Currency</mat-label>
      <mat-select
        formControlName="CURRENCYID"
        (selectionChange)="CurrencyClassChange($event.value)"
        panelClass="lookup-select-panel"
        [disableOptionCentering]="true"
        panelClass="lookup-select-panel"
      >
        <mat-option *ngFor="let lookupItem of lookupsData" [value]="lookupItem.LOOKUPGUID">
          {{ lookupItem.LOOKUPFULLVALUE }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="main-div" fxFlex="80">
      <!-- <button mat-flat-button="" (click)="getValue()"
    class="ml-4 ng-tns-c142-6 mdc-button spend-money-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base "><span
  class="mat-mdc-button-persistent-ripple mdc-button__ripple"></span><mat-icon
  role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
  data-mat-icon-type="svg" data-mat-icon-name="plus"
  data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
  fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
  width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
  d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
</svg></mat-icon><span class="mdc-button__label"><span
class="ml-2 mr-1">Add</span></span><span
class="mat-mdc-focus-indicator"></span><span matripple=""
class="mat-ripple mat-mdc-button-ripple"></span><span
class="mat-mdc-button-touch-target"></span></button> -->
      <button
        mat-flat-button=""
        color="accent"
        class="top-botton spend-money-button btn-text mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
        (click)="getValue()"
      >
        <mat-icon class="fs-21">add</mat-icon>
        Add
      </button>
      <button
        mat-flat-button=""
        color="accent"
        class="bottom-button mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 spend-money-button"
        (click)="AddDuplicateData()"
      >
        <!-- (click)="addDuplicateActivities('Duplicate')" -->
        <mat-icon class="fs-21">file_copy</mat-icon>
        Duplicate
      </button>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-card appearance="outlined" class="table-width mt-6">
      <div class="customer table-div height-435">
        <!-- <table class="simple" [@animateStagger]="{value:'50'}">
      <tbody>
        <tr>
          <th>Effective Date</th>
          <th>Rate</th>
        </tr>
        <tr *ngFor="let item of getDataForTable; let index = index"
          (click)="rowclick(item ,index);highlightedRows=index"
          [style.background]="highlightedRows == index ? selectedColore : ''"
          [ngClass]="highlightedRows == index ? 'row-text-colore' : ''" matRipple
          [@animate]="{value:'*',params:{y:'100%'}}">
          <td>{{item.EFFECTIVEDATE}}</td>
          <td>{{item.RATE}}</td>
        </tr>
      </tbody>
    </table> -->
        <table mat-table [dataSource]="getDataForTable" class="simple" multiTemplateDataRows>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Effective Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.EFFECTIVEDATE }}
            </td>
          </ng-container>
          <ng-container matColumnDef="rate">
            <th mat-header-cell *matHeaderCellDef>Rate</th>
            <td style="padding: 0px 8px" mat-cell *matCellDef="let element">
              {{ element.RATE }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Action">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="text-align: center; padding-right: 25px; width: 80px"
            >
              <!-- <button mat-flat-button="" (click)="getValue()"
          class="ml-4 ng-tns-c142-6 mdc-button spend-money-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"><span
        class="mat-mdc-button-persistent-ripple mdc-button__ripple"></span><mat-icon
        role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
        data-mat-icon-type="svg" data-mat-icon-name="plus"
        data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
        width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg></mat-icon><span class="mdc-button__label"><span
    class="ml-2 mr-1">Add</span></span><span
  class="mat-mdc-focus-indicator"></span><span matripple=""
class="mat-ripple mat-mdc-button-ripple"></span><span
class="mat-mdc-button-touch-target"></span></button> -->
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              style="text-align: center; padding: 0px 0px; width: 80px"
            >
              <div class="ng-tns-c142-6 ml-4">
                <button
                  matIconButton
                  (click)="toggleRow(element)"
                  class="spend-money-dropdown flex items-center border border-black/12 text-black"
                >
                  <mat-icon class="items-center justify-center text-2xl">
                    {{ element.expanded ? 'keyboard_arrow_down' : 'edit' }}
                  </mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="header-row-first-group" class="mt-4">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="12px"
                class="w-full py-4"
              >
                <mat-form-field appearance="outline" class="w-[180px]">
                  <mat-label>Effective Date</mat-label>

                  <input
                    matInput
                    formControlName="EFFECTIVEDATE"
                    [matDatepicker]="ExchangeDate"
                    (dateInput)="exchangeDate1('input', $event)"
                    (dateChange)="exchangeDate('change', $event)"
                  />

                  <mat-datepicker-toggle matSuffix [for]="ExchangeDate"></mat-datepicker-toggle>

                  <mat-datepicker #ExchangeDate></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-[180px]">
                  <mat-label>Exchange Rate</mat-label>

                  <input matInput type="number" formControlName="RATE" [disabled]="secondData" />
                </mat-form-field>

                <button matButton="filled" color="primary" (click)="finalSave('save')">Save</button>

                <button matButton="tonal" color="warn" (click)="maintainFlag = false">
                  Cancel
                </button>
              </div>
            </th>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedColumns.length"
              style="padding: 0px 8px"
            >
              <div
                class="example-element-detail"
                animate.enter="detail-expand-in"
                animate.leave="detail-expand-out"
              >
                <div fxLayout="row" fxLayoutAlign="start center" class="py-4">
                  <mat-form-field
                    appearance="outline"
                    class="example pr-1"
                    fxFlex="30"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Effective Date</mat-label>
                    <input
                      (dateInput)="exchangeDate1('input', $event)"
                      (dateChange)="exchangeDate('change', $event)"
                      formControlName="EFFECTIVEDATE"
                      matInput
                      name="Effective Date"
                      [matDatepicker]="ExchangeDate"
                      placeholder="Exchange Rate"
                    />
                    <mat-datepicker-toggle matSuffix [for]="ExchangeDate"></mat-datepicker-toggle>
                    <mat-datepicker #ExchangeDate></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    fxFlex="30"
                    class="pr-1"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Exchange Rate</mat-label>
                    <input
                      formControlName="RATE"
                      type="number"
                      [disabled]="secondData"
                      name="RATE"
                      placeholder="Exchange Rate"
                      matInput
                    />
                  </mat-form-field>

                  <div class="ml-4 flex items-center gap-2">
                    @if (ShowDuplicateBotton == false) {
                      <button
                        (click)="finalSave('save')"
                        class="ng-tns-c142-6 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary spend-money-updates mat-mdc-button-base"
                        mat-raised-button
                        color="accent"
                        cdkFocusInitial
                      >
                        Update
                      </button>
                    }
                    @if (ShowDuplicateBotton == false) {
                      <button
                        (click)="itemChange('delete')"
                        class="btn-add-2 ng-tns-c142-6 mdc-button mat-mdc-button mat-warn mat-mdc-button-base spend-money-deletes pr-1"
                        mat-button
                        cdkFocusInitial
                      >
                        Delete
                      </button>
                    }
                    @if (ShowDuplicateBotton == true) {
                      <button
                        (click)="CollapstExpandedrow()"
                        mat-button
                        color="warn"
                        class="activity-drop-button btn-red"
                      >
                        Cancel
                      </button>
                    }
                    @if (ShowDuplicateBotton == true) {
                      <button
                        (click)="itemChange('DUPLICATE')"
                        mat-raised-button
                        color="accent"
                        class="cancel disabled-colore ng-tns-c142-6 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary spend-money-updates mat-mdc-button-base"
                        mat-button
                      >
                        @if (isspiner) {
                          <mat-spinner diameter="24"></mat-spinner>
                        }
                        Duplicate
                      </button>
                    }
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr
            class="mat-header-row-r"
            mat-header-row
            *matHeaderRowDef="['header-row-first-group']"
            [ngClass]="maintainFlag ? '' : 'hideRow'"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="rowclick(row); highlightedRows = row.EXCHANGERATEGUID"
            [style.background]="highlightedRows == row.EXCHANGERATEGUID ? selectedColore : ''"
            [ngClass]="highlightedRows == row.EXCHANGERATEGUID ? 'row-text-colore' : ''"
            class="example-element-row"
            [class.example-expanded-row]="row.expanded"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow"
            class="example-detail-row"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center! text-[14px]" [attr.colspan]="displayedColumns.length">
              There is no data to display.
            </td>
          </tr>
        </table>
      </div>
    </mat-card>
  </div>
  <!-- <mat-dialog-actions fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" align="end" class="popup_ftr">
<button [disabled]="firstData" (click)="itemChange('add')" fxFlex="30" class="pr-1 btn-add" mat-raised-button
color="accent" cdkFocusInitial>New</button>
<button [disabled]="firstData" (click)="itemChange('edit')" fxFlex="30" class="pr-1 btn-add" mat-raised-button
color="accent" cdkFocusInitial>Edit</button>
<button [disabled]="firstData" (click)="itemChange('delete')" fxFlex="30" class="pr-1 btn-add" matButton="filled" cdkFocusInitial>Delete</button>
</mat-dialog-actions>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <mat-form-field appearance="outline" class="example" fxFlex="49" class="pr-1">
    <mat-label>Effective Date</mat-label>
    <input (dateInput)="exchangeDate1('input', $event)" (dateChange)="exchangeDate('change', $event)"
      formControlName="EFFECTIVEDATE" matInput name="Effective Date" [matDatepicker]="ExchangeDate"
      placeholder="Exchange Rate">
      <mat-datepicker-toggle matSuffix [for]="ExchangeDate"></mat-datepicker-toggle>
      <mat-datepicker #ExchangeDate></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Exchange Rate</mat-label>
      <input formControlName="RATE" type="number" [disabled]="secondData" name="RATE" placeholder="Exchange Rate"
        matInput>
      </mat-form-field>
    </div>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" align="end" class="popup_ftr">
      <button [disabled]="secondData" (click)="finalSave('save')" fxFlex="20" class="pr-1 btn-add-2" mat-raised-button
      color="accent" cdkFocusInitial>Save</button>
      <button [disabled]="secondData" (click)="dontsave()" fxFlex="20" class="pr-1 btn-add-2" mat-raised-button
      color="primary" cdkFocusInitial>Don't Save</button>
    </mat-dialog-actions> -->
</div>
